import { ActionType } from 'models/action-type.enum';
import { Microzone, PaymentMethodsDescription } from 'models/microzone';
import { TimerConfig } from 'models/timer-config';
import { AnyAction, Reducer } from 'redux';

import {
  GET_MICROZONES,
  HOVER_ZONE,
  SET_MICROZONES,
  SET_PAYMENT_METHODS,
  SET_SELECTED_MICROZONE,
  SET_SELECTED_TYPE_ACTION,
  SET_WHIM_DATA
} from './microzones.types';
import { ZoneVerticals } from 'models/zoneVerticals';

export interface MicrozonesState {
  selectedMicrozones: Array<string>;
  microzones: Array<Microzone>;
  loadingMicrozones: boolean;
  hoveredZone?: Microzone;
  updatingZones: boolean;
  timerConfigs: Array<TimerConfig>;
  paymentMethods: Array<PaymentMethodsDescription>;
  actionTypeSelected: ActionType;
  zonesVerticals: ZoneVerticals[];
}

const initialState: MicrozonesState = {
  selectedMicrozones: [],
  loadingMicrozones: false,
  microzones: [],
  hoveredZone: undefined,
  updatingZones: false,
  timerConfigs: [],
  paymentMethods: [],
  actionTypeSelected: ActionType.Eventualities,
  zonesVerticals: []
};

const reducer: Reducer<MicrozonesState> = (
  state: MicrozonesState = initialState,
  action: AnyAction = { type: undefined }
) => {
  switch (action.type) {
    case SET_SELECTED_MICROZONE:
    case SET_SELECTED_TYPE_ACTION:
    case HOVER_ZONE:
    case SET_PAYMENT_METHODS:
    case SET_WHIM_DATA:
      return {
        ...state,
        ...action.payload
      };

    case SET_MICROZONES:
      return {
        ...state,
        ...action.payload,
        loadingMicrozones: false
      };

    case GET_MICROZONES:
      return {
        ...state,
        loadingMicrozones: true
      };

    default:
      return state;
  }
};

export default reducer;
